"use strict";

import * as React from "react";
import PropTypes from "prop-types";
import UserProduct from "./UserProduct.jsx";
import productFilter from "../../../utilities/OrganizationProductFilter";

const UserProducts = props => {

    const userProducts = props.userProducts;

    const products = !props.organizationProducts ? null : productFilter.filterProductsJS(props.organizationProducts).map(function (product) {
        if (!product) return;

        const userProduct = userProducts.filter(up => up.productId === product.productId);

        const assigned = userProduct && userProduct.length > 0;
        const defaultRole = product.roles.find(role => role.isDefault);
        const userRoleId = assigned && userProduct[0].roleId ? userProduct[0].roleId : (defaultRole ? defaultRole.id : 0);

        return (<UserProduct key={product.productId}
            productName={product.productName}
            productId={product.productId}
            productRoles={product.roles}
            userRoleId={userRoleId}
            assigned={assigned}
            selectProduct={props.selectProduct}
            selectRole={props.selectRole}
        />);
    });

    return (
        <div id="UserProducts" className="col-md-12 control-row">
            <div className="col-md-4 formControlTitle">
                <span>Product</span>
            </div>
            <div className="col-md-4 formControlTitle">
                <span>Role</span>
            </div>
            <div>
                {products}
            </div>
        </div>
    );
};

UserProducts.propTypes = {
    organizationProducts: PropTypes.any,
    userProducts: PropTypes.any,
    selectProduct: PropTypes.func,
    selectRole: PropTypes.func
};

export default UserProducts;
